/***
*
*   EVENT/DETAIL
*   View the details of an individual user
*
**********/

import { useEffect, useState } from 'react';
import { Animate, Card, Breadcrumbs, Form, useAPI, useLocation } from 'components/lib';

export function UserDetail(props) {

    const location = useLocation();
    const path = location?.pathname?.split('/');
    const id = path[2];

    // fetch
    const user = useAPI(`/api/user/${id}`);
    const [form, setForm] = useState(null);

    useEffect(() => {
        if (user.data?.length) {

            const userData = {};
            /*
             * This code block is iterating over the keys of the first object in the user.data array.
             * For each key, it checks if the key is 'workspaces' and if the data associated with the key is truthy.
             * If the conditions are met, it iterates over the data object.
             * For each workspace in the data object, it checks if the workspace data is an object.
             * If it is an object, it iterates over the keys in the workspace data object.
             * For each key in the workspace data object, it checks if the key exists in the userData object.
             * If it doesn't exist, it creates a new object with the key as the label, an empty array as the value, and the type as 'text' if the workspace value is truthy, otherwise null.
             * It then pushes the workspace value into the value array of the userData object.
             * If the workspace data is not an object, it checks if the workspace exists in the userData object.
             * If it doesn't exist, it creates a new object with the workspace as the label, an empty array as the value, and the type as 'text' if the data workspace is truthy, otherwise null.
             * It then pushes the data workspace into the value array of the userData object.
             * If the key is not 'workspaces' or the data associated with the key is falsy, it creates a new object in the userData object with the key as the label, the data as the value, and the type as 'text' if the data is truthy, otherwise null.
             */
            Object.keys(user.data[0]).forEach(key => {
                const data = user.data[0][key];
                if (key === 'workspaces' && data) {
                    for (const workspace in data) {
                        const workspaceData = data[workspace];
                        if (typeof workspaceData === 'object') {
                            for (const workspaceKey in workspaceData) {
                                const workspaceValue = workspaceData[workspaceKey];
                                if (!userData[workspaceKey]) {
                                    userData[workspaceKey] = {
                                        label: workspaceKey,
                                        value: [],
                                        type: workspaceValue ? 'text' : null,
                                    }
                                }
                                userData[workspaceKey].value.push(workspaceValue);
                            }
                        } else {
                            if (!userData[workspace]) {
                                userData[workspace] = {
                                    label: workspace,
                                    value: [],
                                    type: data[workspace] ? 'text' : null,
                                }
                            }
                            userData[workspace].value.push(data[workspace]);
                        }
                    }
                } else {
                    userData[key] = {
                        label: key,
                        value: data,
                        type: data ? 'text' : null,
                    }
                }
            });

            setForm(userData);
        }
    }, [user.data])

    return (
        <Animate>

            <Breadcrumbs items={[
                { name: 'groups', url: '/users' },
                { name: id, url: `/users` },
                { name: 'detail', url: `/users/${id}` }
            ]} />

            <Card loading={user.loading}>

                {form &&
                    <Form inputs={form} />}

            </Card>
        </Animate>
    )
}